import styled from 'styled-components'

export const ActionMenuScrollingArea = styled.div`
  padding: ${props => props.theme.spacings.xxsmall};
  max-height: 400px;
  overflow-y: auto;
`
